import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import Swiper from 'swiper'

gsap.registerPlugin(ScrollTrigger)

export const initTestimonials = () => {

	const el = document.querySelector('.testimonials')
	const tagline = el?.querySelector('.testimonials__tagline')
	const heading = el?.querySelectorAll('.testimonials__heading span')
	const slider = el?.querySelector('.testimonials__slider')
	const track = slider?.querySelector('.swiper-wrapper')
	const items = slider?.querySelectorAll('.testimonials__item')

	if (!el) return
	if (window.innerWidth > 1024) desktopSetup()
	if (window.innerWidth <= 1024) mobileSetup()

	function desktopSetup() {
		const trackLength = items[0].offsetWidth * items.length

		const main = gsap.timeline({
			scrollTrigger: {
				trigger: el,
				pin: true,
				start: 'top top',
				end: `+=${items.length * 1000}px`,
				scrub: 0.75
			}
		})

		const tl = gsap.timeline()

		tl.to(tagline, {
			duration: 0.25,
			opacity: 0 
		})
		tl.to(heading[0], {
			duration: 1,
			x: -1000,
			scale: 0.9,
			opacity: 0, 
			filter: 'blur(6px)',
			ease: 'power1.inOut'
		}, '<')
		tl.to(heading[1], {
			duration: 1,
			x: 1000,
			scale: 0.9,
			opacity: 0,
			filter: 'blur(6px)',
			ease: 'power1.inOut'
		}, '<')
		tl.to(slider, {
			scale: 1,
			opacity: 1,
			filter: 'blur(0px)',
			duration: 1.25
		}, '-=0.75')

		const scroller = gsap.timeline()

		scroller.to(track, {
			duration: 2.5,
			x: -trackLength,
			ease: 'none'
		}, '-=1.5')

		main.add(tl)
		main.add(scroller, '-=0.4')

		items.forEach((item) => {
			const content = item.querySelector('.testimonials__content')
			const image = item.querySelector('.testimonials__image')
			const depth = gsap.timeline({
				scrollTrigger: {
					trigger: item,
					containerAnimation: tl,
					start: 'left 80%',
					end: 'right 20%',
					scrub: 1
				}
			})
			depth.to(item, {
				scale: 1,
				opacity: 1,
				filter: 'blur(0px)',
				ease: 'none'
			})
			depth.to([content, image], {
				boxShadow: '0px 149px 42px 0px rgba(0, 0, 0, 0), 0px 96px 38px 0px rgba(0, 0, 0, 0.01), 0px 54px 32px 0px rgba(0, 0, 0, 0.03), 0px 24px 24px 0px rgba(0, 0, 0, 0.05), 0px 6px 13px 0px rgba(0, 0, 0, 0.06)'
			}, '<')
		})
	}

	function mobileSetup() {
		const swiper = new Swiper(slider, {
			speed: 750,
			spaceBetween: 18,
			slidesPerView: 1.2,
			centeredSlides: true,
			breakpoints: {
        651: {
          spaceBetween: 24,
          slidesPerView: 1.1,
					centeredSlides: true
        }
      }
		})
	}
}

export default () => {}